"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.markRosterRowSigned = markRosterRowSigned;
/**
 * Flip the roster row a signer just satisfied to "signed", so the signature
 * list shows their mark without a round trip.
 *
 * Returns a fresh array (and fresh row objects) because ds-signature-list is an
 * ngVue component: its prop watcher only re-renders on a new reference.
 */
function markRosterRowSigned(roster, matches, signature_data, signed_at) {
    if (signed_at === void 0) { signed_at = new Date().toISOString(); }
    return (roster || []).map(function (row) {
        return matches(row)
            ? __assign(__assign({}, row), { status: "signed", signature_data: signature_data, signed_at: signed_at }) : row;
    });
}
